var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box-sample",class:_vm.classes,attrs:{"sentry-tag":"dashboard-widget-single"}},[_c('h3',[_vm._v(_vm._s(_vm.value))]),_c('p',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }